import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import IconUsers from "../SvgIcon/IconUsers";
import IconUserWiseReport from "../SvgIcon/IconUserWiseReport";
import CountUp from "react-countup";
import api from "../../services";
import IconCustomers from "../SvgIcon/IconCustomers";
import { useAuth } from "../../services/AuthContext";
import IconLocation from "../SvgIcon/IconLocation";
import "./style.css";
import IconUpcomingLeaves from "../SvgIcon/IconUpcomingLeaves";

export default function Cards() {
  const { userType, country } = useAuth();
  const [statistics, setStatistics] = useState({});

  useEffect(() => {
    const fetchCounts = async () => {
      try {
        const dashboardStats = await api.post("/stats", { Country: country });
        setStatistics(dashboardStats.data.statistics);
      } catch (error) {
        console.error("Failed to fetch stats:", error);
        setStatistics({ on_leave_today: 0, upcoming_Leaves: 0, users: 0, companies: 0, customers: 0 }); // fallback to zero
      }
    };

    fetchCounts();
  }, [userType, country]);

  return (
    <div className="topcards">
      {/* --- Today User Leaves  --- */}
      <div className="stretch-card grid-margin">
        <Link
          to="/leaves"
          className="card bg-gradient-success card-img-holder text-white"
        >
          <div className="card-body">
            <img
              src="../images/Card-circle.svg"
              className="card-img-absolute"
              alt="circle"
            />
            <div className="card-info">
              <h4 className="card-title mb-2 d-flex align-items-center justify-content-between">
                On Leave Today

              </h4>
              <h6 className="card-text">Today’s Leave Overview</h6>
            </div>

            <IconUserWiseReport />
            <h2>
              <CountUp end={statistics.on_leave_today} duration={1.5} />
            </h2>

          </div>
        </Link>
      </div>

      {/* --- Upcoming Leave --- */}
      <div className="stretch-card grid-margin">
        <Link
          to="/leaves"
          className="card bg-dark card-img-holder text-white"
        >
          <div className="card-body">
            <img
              src="../images/Card-circle.svg"
              className="card-img-absolute"
              alt="circle"
            />
            <div className="card-info">
              <h4 className="card-title mb-2 d-flex align-items-center justify-content-between">
                Upcoming Leaves
              </h4>
              <h6 className="card-text">
                Future Leave Activity
              </h6>
            </div>
            <IconUpcomingLeaves />
            <h2>
              <CountUp end={statistics.upcoming_Leaves} duration={1} separator="," />
            </h2>

          </div>
        </Link>
      </div>


      {/* --- Users --- */}
      <div className="stretch-card grid-margin">
        <Link
          to="/user-list"
          className="card bg-gradient-primary card-img-holder text-white"
        >
          <div className="card-body">
            <img
              src="../images/Card-circle.svg"
              className="card-img-absolute"
              alt="circle"
            />
            <div className="card-info">
              <h4 className="card-title mb-2 d-flex align-items-center justify-content-between">
                Users
              </h4>
              <h6 className="card-text">
                {userType === "Super"
                  ? "Total Users (All Countries)"
                  : `Total Users (${country})`}
              </h6>
            </div>
            <IconUsers />
            <h2>
              <CountUp end={statistics.users} duration={1} separator="," />
            </h2>

          </div>
        </Link>
      </div>

      {/* --- Locations --- */}
      <div className="stretch-card grid-margin">
        <Link
          to="/location-list"
          className="card bg-gradient-danger card-img-holder text-white"
        >
          <div className="card-body">
            <img
              src="../images/Card-circle.svg"
              className="card-img-absolute"
              alt="circle"
            />
            <div className="card-info">
              <h4 className="card-title mb-2 d-flex align-items-center justify-content-between">
                Locations
              </h4>
              <h6 className="card-text">
                {userType === "Super"
                  ? "Location list (All Countries)"
                  : `Location (${country})`}
              </h6>
            </div>
            <IconLocation />
            <h2>
              <CountUp end={statistics.companies} duration={1} separator="," />
            </h2>

          </div>
        </Link>
      </div>

      {/* --- Customers --- */}
      <div className="stretch-card grid-margin">
        <Link
          to="/party-list"
          className="card bg-gradient-info card-img-holder text-white"
        >
          <div className="card-body">
            <img
              src="../images/Card-circle.svg"
              className="card-img-absolute"
              alt="circle"
            />
            <div className="card-info">
              <h4 className="card-title d-flex align-items-center justify-content-between">
                Customers
              </h4>
              <h6 className="card-text">
                {userType === "Super"
                  ? "Total Customers (All Countries)"
                  : `Total Customers (${country})`}
              </h6>
            </div>
            <IconCustomers />
            <h2>
              <CountUp end={statistics.customers} duration={2} separator="," />
            </h2>

          </div>
        </Link>
      </div>

    </div>
  );
}
